import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { TCargoGeral } from "../../../../types";

interface GetMembrosProps {

}


type ResponseMembrosCheckin = {
  listAll: TCargoGeral[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: TCargoGeral[]
  pagina: number
}

const GetCargoList = (): ResponseMembrosCheckin => {

  const [listMinisterioGrupo, setMinisterioGrupo] = useState<TCargoGeral[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<TCargoGeral[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = (params: any) => {
    api.get<TCargoGeral[]>('ministerio/cargo/geral/v2/listar', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setMinisterioGrupo(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<TCargoGeral[]>('ministerio/cargo/geral/v2/listar')
      .then(
        (sucesso) => {
          setMinisterioGrupo(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, [resetar]);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listMinisterioGrupo,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams
  };
}

export default GetCargoList;
